const maybeBlacklistedOverlay = () => {

  if(window.currentUser && window.currentUser.blacklisted && window.currentUser.blacklisted == 1) {
    $('.content-container').addClass('overlay overlay--blurred');
    window.logoutNoRedirect();
    window.location.href = window.site.home + '/?redirect=blacklist';
    return true;
  }

  return false;

};

export default maybeBlacklistedOverlay;
